import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import cartService from '../services/cartService'

const CartContext = createContext(null)

export const CartProvider = ({ children }) => {
  const location = useLocation()
  const [cartItemCount, setCartItemCount] = useState(0)
  const [cartLoading, setCartLoading] = useState(false)

  const refreshCartCount = useCallback(async () => {
    const token = localStorage.getItem('token')
    if (!token) {
      setCartItemCount(0)
      return 0
    }

    setCartLoading(true)
    try {
      const cart = await cartService.getUserCart()
      const items = cartService.normalizeCartLineItems(cart)
      setCartItemCount(items.length)
      return items.length
    } catch (error) {
      console.error('Failed to refresh cart count:', error)
      setCartItemCount(0)
      return 0
    } finally {
      setCartLoading(false)
    }
  }, [])

  const clearCartCount = useCallback(() => {
    setCartItemCount(0)
  }, [])

  useEffect(() => {
    refreshCartCount()
  }, [location.pathname, refreshCartCount])

  const value = useMemo(
    () => ({
      cartItemCount,
      cartLoading,
      refreshCartCount,
      clearCartCount
    }),
    [cartItemCount, cartLoading, refreshCartCount, clearCartCount]
  )

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>
}

export const useCart = () => {
  const context = useContext(CartContext)
  if (!context) {
    throw new Error('useCart must be used within a CartProvider')
  }
  return context
}
